import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  role: [],
  columns: [
    {
      label: 'Periode', field: 'period'
    },
    {
      label: 'Date Start', field: 'date_start'
    },
    {
      label: 'Date Finish', field: 'date_finish'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/app-kpis/status/AC'}
    useIPA.get(param).then(response => {
      const kpi = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...kpi})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/app-kpi/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        priv_ctgr_id: parseInt(formData.select_1),
        code: formData.text_2,
        name: formData.text_3,
        icon: formData.text_4,
        slug: formData.text_5,
        url: formData.text_6 
			}
      const param = { rawData: rawData, url: 'dashboard/master/app-kpi', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'kpi' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/app-kpi', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, kpi) {
    state.all = kpi.rows
    state.pages = kpi.pages
    // for (let i = 0; i < kpi.rows.length; i++) {
    //   const option = []
    //   for (const key in kpi.rows[i]) {
    //     option['module'] = kpi.rows[i]['name'] 
    //     option['access'] = kpi.rows[i]['id'] 
    //   } 
    //   state.role.push(Object.assign({}, option))
    // }
    // console.log(state.role)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
